export default __webpack_public_path__ + "static/media/Connecticut4Open.16bbe41a.jpg";